import { useCallDataExtraction } from 'app/components/call-data-extraction/useCallDataExtraction'
import { CallDataExtractionShadcnComponent } from 'app/components/call-data-extraction/CallDataExtractionShadcnComponent'

export default function CallDataExtraction() {
  const props = useCallDataExtraction()
  return <CallDataExtractionShadcnComponent {...props} />
}
